import { render } from "./itemText.vue?vue&type=template&id=7688dcab&scoped=true"
import script from "./itemText.vue?vue&type=script&lang=js"
export * from "./itemText.vue?vue&type=script&lang=js"

import "./itemText.vue?vue&type=style&index=0&id=7688dcab&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7688dcab"]])

export default __exports__